<template>
    <b-modal
        no-fade
        ref="dialog"
        title-tag="h2"
        :title="modalTitle"
        lazy
        no-enforce-focus
        no-close-on-backdrop
        no-close-on-esc
        @hidden="reset"
        @hide="clearDraft"
        @shown="$emit('shown')"
        :scrollable="viewClient || viewConfirmation"
    >
        <view-reservation v-if="viewReservation" />
        <view-split
            v-else-if="viewSplit"
            ref="splitview"
            @clear-draft="clearDraft"
            :directSplitMode="directSplitMode"
        />
        <view-client v-else-if="viewClient" />
        <view-confirmation v-else-if="viewConfirmation" />

        <template v-if="isSaving" v-slot:modal-footer>
            <loader :margin="1" />
        </template>
        <template v-else v-slot:modal-footer="{ cancel }">
            <b-button @click="cancel">Cancel</b-button>
            <div class="gap"></div>

            <b-button
                v-if="viewSplit"
                :class="{ btnsplit: true, noclick: isSplitButtonDisabled }"
                :disabled="isSplitButtonDisabled"
                @click="applySplit"
            >
                Split
            </b-button>
            <b-button
                v-if="viewStack.length > 0"
                @click="back"
                variant="primary"
            >
                Back
            </b-button>
            <b-dropdown
                v-if="viewReservation && !noSplitOption"
                right
                split
                text="Next"
                variant="primary"
                @click="next"
                :disabled="disableNextButton"
            >
                <b-dropdown-item @click="split">
                    Split
                </b-dropdown-item>
            </b-dropdown>
            <b-button
                v-if="
                    viewClient ||
                    viewSplit ||
                    (viewReservation && noSplitOption)
                "
                @click="next"
                variant="primary"
                :disabled="disableNextButton"
            >
                Next
            </b-button>
            <b-button
                v-if="viewConfirmation"
                variant="primary"
                @click="saveReservation"
            >
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import ViewClient from "./client.vue";
import ViewConfirmation from "./confirmation.vue";
import ViewReservation from "./reservation.vue";
import ViewSplit from "./split.vue";
import BoardingService from "@/services/boarding.js";
import Loader from "@/module/commons/loader";
import moment from "moment";

const RESERVATION = "RESERVATION";
const CLIENT_INFORMATION = "CLIENT_INFORMATION";
const CONFIRMATION = "CONFIRMATION";
const SPLIT_RESERVATION = "SPLIT_RESERVATION";

export default {
    components: {
        ViewClient,
        ViewConfirmation,
        ViewReservation,
        ViewSplit,
        Loader
    },
    props: {
        session: {
            type: String,
            default: ""
        },
        noSplitOption: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // previousView: null,
            directSplitMode: false,
            isSaving: false,
            blockerIds: [], // list of blocker ids -- to be used on close, to clear all temporary slot block
            viewStack: [],
            view: {
                RESERVATION,
                CLIENT_INFORMATION,
                CONFIRMATION,
                SPLIT_RESERVATION
            }
        };
    },
    computed: {
        disableNextButton() {
            let view = this.$store.state.modalReservation.view;

            if (this.viewReservation) {
                let v = view.RESERVATION;
                if (
                    v.selectedClient === null ||
                    v.selectedPatient === null ||
                    v.dateCheckIn === null ||
                    v.dateCheckOut === null ||
                    v.selectedRoom === null ||
                    v.selectedProvider === null
                ) {
                    return true;
                }
            }

            if (this.viewSplit) {
                if (this.directSplitMode) {
                    if (this.bookings.length === 0) {
                        return true;
                    }
                } else {
                    if (this.bookings.length === 1) {
                        return true;
                    }
                }
            }

            return false;
        },
        viewReservation() {
            return this.currentView === RESERVATION;
        },
        viewSplit() {
            return this.currentView === SPLIT_RESERVATION;
        },
        viewClient() {
            return this.currentView === CLIENT_INFORMATION;
        },
        viewConfirmation() {
            return this.currentView === CONFIRMATION;
        },
        isExternal: {
            get() {
                return this.$store.state.modalReservation.isExternal;
            },
            set(value) {
                this.storeCommit("setIsExternal", value);
            }
        },
        isEditMode: {
            get() {
                return this.$store.state.modalReservation.isEditMode;
            },
            set(value) {
                this.storeCommit("setEditMode", value);
            }
        },
        modalTitle: {
            get() {
                return this.$store.state.modalReservation.modalTitle;
            },
            set(value) {
                this.storeCommit("setModalTitle", value);
            }
        },
        currentView: {
            get() {
                return this.$store.state.modalReservation.currentView;
            },
            set(value) {
                this.storeCommit("setCurrentView", value);
            }
        },
        isLoadingFooterPreview: {
            get() {
                return this.$store.state.modalReservation
                    .isLoadingFooterPreview;
            },
            set(value) {
                this.storeCommit("setIsLoadingDetails", value);
            }
        },
        bookings: {
            get() {
                return this.$store.state.modalReservation.bookings;
            },
            set(value) {
                this.storeCommit("setBookings", value);
            }
        },
        isProceedSplit() {
            return this.$store.state.modalReservation.isProceedSplit;
        },
        isSplitButtonDisabled() {
            let {
                dateCheckIn,
                dateCheckOut,
                selectedRoom
            } = this.$store.state.modalReservation.view.SPLIT_RESERVATION;

            if (dateCheckIn && dateCheckOut && selectedRoom) {
                return false;
            }
            return true;
        }
    },
    methods: {
        async saveReservation() {
            try {
                this.isSaving = true;

                let { bookings, view } = this.$store.state.modalReservation;
                let {
                    CLIENT_INFORMATION: CLIENT,
                    CONFIRMATION,
                    RESERVATION
                } = view;

                let dataBookings = [];
                for (let n = 0; n < bookings.length; n++) {
                    let book = bookings[n];
                    let isMain = n === 0;

                    if (this.directSplitMode) {
                        isMain = false;
                    }

                    dataBookings.push({
                        start: book.startUnix,
                        end: book.endUnix,
                        room_id: book.roomId,
                        is_main: isMain
                    });

                    if (n === 0 && !this.isProceedSplit) {
                        break;
                    }
                }

                let cOption = CONFIRMATION.confirmation.selectedOption;
                let cMessage = CONFIRMATION.confirmation.message;
                if (cOption === 0) {
                    cMessage = "";
                }

                let rOption = CONFIRMATION.reminder.selectedOption;
                let rMessage = CONFIRMATION.reminder.message;
                if (rOption === 4) {
                    rMessage = "";
                }

                /**
                 * clientBirthdate : get client birthdate in yyyy-MM-dd format
                 * @type string
                 */
                let clientBirthdate = CLIENT.birthDate
                    ? this._fromDateStrToDateTime(CLIENT.birthDate)?.toFormat(
                          "yyyy-MM-dd"
                      )
                    : "";

                let data = {
                    provider_id: RESERVATION.selectedProvider.id,
                    client_id: RESERVATION.selectedClient.id,
                    patient_id: RESERVATION.selectedPatient.id,
                    patient_name: RESERVATION.selectedPatient.name,
                    note: RESERVATION.notes,
                    confirmation_option: cOption,
                    confirmation_message: cMessage,
                    reminder_send: CONFIRMATION.reminder.send.value, // the "n" Days/Weeks etc
                    reminder_time_period: CONFIRMATION.reminder.send.periodType, // Days/Weeks/Months
                    reminder_send_option: CONFIRMATION.reminder.send.option,
                    reminder_type: rOption,
                    reminder_message: rMessage,
                    reminder_note: "",
                    client: {
                        firstname: CLIENT.firstName,
                        lastname: CLIENT.lastName,
                        address: CLIENT.address,
                        zipcode: CLIENT.zipcode,
                        city: CLIENT.city,
                        state: CLIENT.state,
                        country: CLIENT.country,
                        birthdate: clientBirthdate || null,
                        email: CLIENT.email,
                        driver_license: CLIENT.driverLicense,
                        home_country_code: CLIENT.phone.home.countryCode,
                        home: CLIENT.phone.home.number,
                        mobile_country_code: CLIENT.phone.mobile.countryCode,
                        mobile: CLIENT.phone.mobile.number,
                        work_country_code: CLIENT.phone.work.countryCode,
                        work: CLIENT.phone.work.number,
                        fax_country_code: CLIENT.phone.fax.countryCode,
                        fax: CLIENT.phone.fax.number,
                        reminders: CLIENT.reminders
                    },
                    bookings: dataBookings
                };

                if (this.isEditMode) {
                    let id = this.$store.state.modalReservation.boardingId;
                    let updated = await BoardingService.updateReservation(
                        id,
                        data
                    );

                    if (updated) {
                        sessionStorage.removeItem('boarding_booking_details_' + id); // prettier-ignore
                        this._message("Reservation updated successfully");
                        this.$refs.dialog.hide();
                        this.$emit("save", id); // pass true means isEdit
                    } else {
                        throw new Error("Error: Unable to update reservation.");
                    }
                } else {
                    let save = await BoardingService.saveReservation(data);

                    if (save) {
                        this._message("Reservation saved successfully");
                        this.$refs.dialog.hide();
                        this.$emit("save");
                    } else {
                        throw new Error("Error: Unable to save reservation.");
                    }
                }
            } catch (error) {
                console.log(error);
                this.isSaving = false;
                this._message(
                    error?.message ?? "Error: Unable to save reservation.",
                    "danger"
                );
            }
        },
        applySplit() {
            this.$refs.splitview.registerBooking();
        },
        storeCommit(mutation, value) {
            this.$store.commit("modalReservation/" + mutation, value);
        },
        /**
         * get check-in, check-out time from settings
         * and store them in vuex
         */
        async setTime() {
            function toTimeString(seconds) {
                return new Date(seconds * 1000).toISOString().substring(11, 16);
            }

            let settings = await BoardingService.getSettings();
            let inTime = toTimeString(settings.resource.check_in);
            let outTime = toTimeString(settings.resource.check_out);

            this.storeCommit("setTime", {
                checkIn: inTime,
                checkOut: outTime
            });

            return { inTime, outTime };
        },
        // open modal for Edit Reservation
        openEdit(details = {}) {
            this.isEditMode = true;
            this.modalTitle = "Edit Reservation";
            this.currentView = RESERVATION;
            this.viewStack = []; // ensure stack is clear

            // clone current state
            let reservationData = {
                ...this.$store.state.modalReservation.view.RESERVATION
            };

            let start = moment.unix(details.start).toDate();
            let end = moment.unix(details.end).toDate();

            // apply data - reservation dialog
            this.storeCommit("setViewState", {
                view: RESERVATION,
                value: {
                    ...reservationData,
                    notes: details.note,
                    dateCheckIn: start,
                    dateCheckOut: end,
                    selectedClient: {
                        id: details.client.id,
                        label: details.client.label
                    },
                    selectedPatient: {
                        id: details.patient.id,
                        name: details.patient.name,
                        label: details.patient.name
                    },
                    selectedRoom: {
                        id: details.room.id,
                        label: details.room.name
                    },
                    selectedProvider: {
                        id: details.staff_id,
                        label: "" // provider's name will be assigned in `fetchProviders` --> see reservation.vue
                    }
                }
            });

            // apply data - client info dialog
            // note: reminder types have to be in Number instead String to work
            let reminderOptions = [];
            for (let r of details.client.reminder_options) {
                let value = Number(r);
                if (isNaN(value)) {
                    continue;
                }
                reminderOptions.push(value);
            }
            this.$store.dispatch("modalReservation/applyClientData", {
                ...details.client,
                reminderOptions
            });

            // boarding id
            this.$store.commit("modalReservation/setBoardingId", details.id);

            this.fetchRoomList();
            this.setTime();
            this.storeCommit("setSession", this.session);
            this.$refs.dialog.show();
        },
        async openFromExternal(params = {}) {
            let { inTime, outTime } = await this.setTime();
            let rooms = await this.fetchRoomList();
            let defaultRoom = rooms[0];
            if (!defaultRoom) {
                this._message(
                    "Unable to proceed. No rooms available.",
                    "danger"
                );
                return;
            }

            let stringFormat = "YYYY-MM-DD HH:mm";
            let startString = moment.tz(this._timeZone).format('YYYY-MM-DD') + " " + inTime; // prettier-ignore
            let endString = moment.tz(this._timeZone).add(1,"day").format('YYYY-MM-DD') + " " + outTime; // prettier-ignore
            let startUnix = moment.tz(startString, stringFormat, this._timeZone).unix(); // prettier-ignore
            let endUnix = moment.tz(endString, stringFormat, this._timeZone).unix(); // prettier-ignore

            let startDate = moment.unix(startUnix).toDate();
            let endDate = moment.unix(endUnix).subtract(1, "day").toDate(); // need to substract 1 day because full calendar auto add 1 day for end date

            this.$refs.dialog.show();
            this.isExternal = true;
            this.open({
                isEditMode: false,
                roomId: defaultRoom.id,
                roomName: defaultRoom.label,
                checkInDate: startDate,
                checkOutDate: endDate,
                blockerId: params.blockerId,
                fromExternal: true
            });
        },
        // open - for New reservation. for Edit purpose, see `openEdit`
        open(params = {}) {
            if (!this._hasAccess("schedule.boarding.create")) {
                return;
            }

            this.isEditMode = false;
            this.modalTitle = "New Reservation";
            this.currentView = RESERVATION;
            this.viewStack = []; // ensure stack is clear
            this.blockerIds = [];

            if (!params.fromExternal) {
                this.fetchRoomList();
                this.setTime();
            }

            this.setRoomAndTime({
                roomId: params.roomId,
                roomName: params.roomName,
                start: params.checkInDate,
                end: params.checkOutDate
            });

            this.blockerIds.push(params.blockerId);
            this.storeCommit("setSession", this.session);
            this.$refs.dialog.show();

            // note: once the first screen is appear, the main booking is registered.
            // see src/module/schedule/boarding/modal-reservation/reservation.vue -> registerBooking
        },
        openSplit(details) {
            this.directSplitMode = true;
            this.isEditMode = false;
            this.modalTitle = "Split Reservation";
            this.currentView = SPLIT_RESERVATION;
            this.viewStack = []; // ensure stack is clear
            this.blockerIds = [];
            this.setTime();
            this.fetchRoomList();
            this.storeCommit("setSession", this.session);

            let mainBookingEnd = moment.unix(details.end).tz(this._timeZone);
            let dateCheckIn = mainBookingEnd.add(1, "day");
            let dateCheckOut = dateCheckIn.clone().add(1, "day");

            // assign values to RESERVATION view
            // even user wont able to see the UI.
            // it will be used when saving
            this.$store.commit("modalReservation/setViewState", {
                view: RESERVATION,
                value: {
                    selectedProvider: {
                        id: details.staff_id
                    },
                    selectedClient: {
                        id: details.client_id
                    },
                    selectedPatient: {
                        id: details.patient_id
                    }
                }
            });

            // use timeout to prevent form reset,
            // as the form will initiate with a form reset
            setTimeout(() => {
                this.$store.commit("modalReservation/setViewState", {
                    view: SPLIT_RESERVATION,
                    value: {
                        dateCheckIn: dateCheckIn,
                        dateCheckOut: dateCheckOut
                    }
                });
            }, 300);

            this.$refs.dialog.show();
        },
        async fetchRoomList() {
            let rawList = await BoardingService.getRoomList();
            let rooms = [];

            // sort by room.name
            rawList.sort((a, b) => {
                const nameA = a.room.name.toUpperCase();
                const nameB = b.room.name.toUpperCase();

                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            for (let rec of rawList) {
                rooms.push({
                    id: rec.id,
                    label: rec.room ? rec.room.name : "--"
                });
            }

            this.storeCommit("setRoomList", rooms);
            return rooms;
        },
        setRoomAndTime({ roomId, roomName, start, end }) {
            let state = this.$store.state.modalReservation.view.RESERVATION;

            this.storeCommit("setViewState", {
                view: RESERVATION,
                value: {
                    ...state,
                    dateCheckIn: start,
                    dateCheckOut: end,
                    selectedRoom: {
                        id: roomId,
                        label: roomName
                    }
                }
            });
        },
        reset() {
            this.storeCommit("reset");
        },
        clearDraft() {
            let ids = [];

            for (let book of this.bookings) {
                ids.push(book.uniqueId2);
            }

            this.$emit("clearblocker", ids);
        },
        changeView(view) {
            switch (view) {
                case RESERVATION:
                    this.modalTitle = (this.isEditMode ? "Edit" : "New") + " Reservation"; // prettier-ignore
                    break;

                case SPLIT_RESERVATION:
                    this.modalTitle = "Split Reservation";
                    break;

                case CLIENT_INFORMATION:
                    this.modalTitle = "Client Information";
                    break;

                case CONFIRMATION:
                    this.modalTitle = "Confirmation";
                    break;

                default:
                    this.modalTitle = "Reservation";
                    break;
            }

            this.currentView = view;
        },
        split() {
            this.viewStack.push(this.currentView);
            this.changeView(SPLIT_RESERVATION);
        },
        next() {
            this.viewStack.push(this.currentView);

            switch (this.currentView) {
                case RESERVATION:
                    this.changeView(CLIENT_INFORMATION);
                    this.storeCommit("proceedSplit", false);
                    break;

                case SPLIT_RESERVATION:
                    this.changeView(CLIENT_INFORMATION);
                    this.storeCommit("proceedSplit", true);
                    break;

                case CLIENT_INFORMATION:
                    this.changeView(CONFIRMATION);
                    break;
            }
        },
        back() {
            let previousView = this.viewStack.pop();
            this.changeView(previousView);
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-footer {
    display: flex;

    .gap {
        flex: 1;
    }
}
.btnsplit {
    width: 80px;

    &.noclick {
        cursor: not-allowed;
    }
}
</style>
